<template>
  <div class="contents">
    <common-header
      :menu="headerMenu"
      :mute="mute"
      :camera-mode="currentCameraMode"
      @button-clicked="onButtonClicked"
      @camera-mode-change="onCameraChange" />
    <settings-modal ref="settings" :settings="settings"
                    :display-value="displayValue"
                    @camera-mode-change="onCameraChange"
                    @settings-change="onSettingChange" />
    <common-display :debug-meg="debugMeg" :navigations="navigations" />
    <side-menu v-show="canShowSideMenu" :menu="sideMenu"
               @button-clicked="onButtonClicked" />
    <title-label :title="title"/>
    <common-modal ref="modal" :steps="steps"/>
    <fill-camera-layout
      @camera-required="start"
      :need-device="{audio:true}"
      :device-state="deviceState"
      :camera-state="manager ? manager.state : null"/>
    <common-footer v-show="canShowFooterMenu" :menu="footerMenu" />
  </div>
</template>

<script>
import "@pqina/flip/dist/flip.min.css";
import {ReiGun} from '../game/ReiGun'
import CommonHeader from "../CommonHeader";
import {CAMERA_MODE} from '../common/CameraRenderer'
import {CommonMixin} from '../common/CommonMixin'
import FillCameraLayout from "../FillCameraLayout";
import CommonDisplay from "../CommonDisplay";
import CommonFooter from "../CommonFooter";
import SideMenu from "../SideMenu";
import CommonModal from "../common/CommonModal";
import SettingsModal from "../common/SettingsModal";
import TitleLabel from "../common/TitleLabel";
import {FitUtil} from "../common/FitUtil";

export default {
  name: 'ReiGun',
  mixins: [CommonMixin],
  components: {
    TitleLabel,
    SettingsModal, CommonModal, SideMenu, CommonFooter, CommonDisplay, FillCameraLayout, CommonHeader},
  data () {
    return {
      defaultCameraMode: CAMERA_MODE.FACE_MASK,
      headerMenu: Object.assign({}, this.defaultHeaderMenu(), {  }),
      sideMenu: Object.assign({}, this.defaultSideMenu(), {}),
      footerMenu: Object.assign({}, this.defaultFooterMenu(), { analytics: false }),
      settings: [
        { key: 'volumeThreshold', type: 'range', label: '反応する声の大きさ', default: FitUtil.isSafari() ? 1 : 9, step:1, min:1, max:60 },
        { key: 'coolDownTime', type: 'range', label: '霊と丸の間(ミリ秒)', default: 800, step:100, min:0, max:5000 },
      ],
      steps: [
        '右手の人差し指を映します',
        '何か適当に声を出します。反応する音量は設定で変更可能です'
      ],
    }
  },
  computed: {
    title() {
      return '必殺技2'
    },
    desc() {
      return '"霊"的な何かが"丸"い形になって飛ぶ完全オリジナル必殺技'
    },
  },
  methods: {
    createContents() {
      return new ReiGun(this.settings);
    },
    // getOptions() {
    //   return {}
    // },
  }
}
</script>

<style scoped>
.contents {
  /*background: black;*/
}
</style>



// WEBPACK FOOTER //
// src/components/contents-page/ReiGun.vue